import { withCloseAfterExited } from "../modal";
import {
  default as View,
  RemoveGroupModalProps
} from "./remove-group-modal-view";

const RemoveGroupModal = withCloseAfterExited<RemoveGroupModalProps>(View);
export default RemoveGroupModal;
